import useIsMobile from 'utils/hooks/useIsMobile'
import {Box} from '@mui/material'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import {DataGridPro, GridRowId} from '@mui/x-data-grid-pro'
import {DateRange} from '@mui/x-date-pickers-pro/DateRangePicker'
import {Dayjs} from 'dayjs'
import {envImagePath} from 'GLOBAL/envVariables'
import MeterariumTabPanel from 'pages/common/TabPanel'
import DeviceAllocationBatchRegisterOffcanvas from 'pages/customer/modules/allocationBatchOffcanvas'
import DeviceFotaBatchOffcanvas from 'pages/customer/modules/allocationFotaBatchOffcanvas'
import {deviceAssignColumns, deviceCheckColumns} from 'pages/device/dataConfig/declearColumns'
import {deviceAssignFilter, deviceCheckFilter} from 'pages/device/dataConfig/declearFilters'
import {deviceAssignGroup, deviceCheckGroup} from 'pages/device/dataConfig/declearGroupingModel'
import {deviceAllocationRows, deviceCheckRows} from 'pages/device/dataConfig/declearRows'
import {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {toast, ToastContainer} from 'react-toastify'
import {
  allocationCancelHandler,
  checkButtonHandler,
  getDeviceAssignList,
  getDeviceCheckList,
} from 'utils/apiCalling/api'
import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {a11yProps, scrollTop, tapHandleChange} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'
import DeviceDetailInfoModal from '../../common/DeviceDetailInfoModal'
import DeviceTargetImageListModal from '../../common/DevicetargetImageListModal'
import DeviceAssignModal from '../modules/DeviceAssignedModal'
import DeviceAllocationMobileCard from './DeviceAllocationMobileCard'

const DeviceAllocation = () => {
  const isMobile = useIsMobile()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const [totalData, setTotalData] = useState<any>(null)
  const [checkSelectionModel, setCheckSelectionModel] = useState<GridRowId[]>([])
  const [assignSelectionModel, setAssignSelectionModel] = useState<GridRowId[]>([])
  const [checkTotalCount, setCheckTotalCount] = useState<number>(0)
  const [assignTotalCount, setAssignTotalCount] = useState<number>(0)
  const [assignedData, setAssignedData] = useState<any>()
  const [value, setValue] = useState(0)
  const [date, setDate] = useState<DateRange<Dayjs>>([null, null])
  const [loading, setLoading] = useState<boolean>(false)
  const [checkSelectCheckbox, setCheckSelectCheckbox] = useState<any>([])
  const [allocationSelectCheckbox, setAllocationSelectCheckbox] = useState<any[]>([])
  const [typeName, setTypeName] = useState<any>('')
  const [deviceDetailData, setDeviceDetailData] = useState<any>(null)
  const [checkFilter, setCheckFilter] = useState<any>(deviceCheckFilter)
  const [assignFilter, setAssignFilter] = useState<any>(deviceAssignFilter)
  const [imageDetailOpen, setImageDetailOpen] = useState<boolean>(false)
  const [deviceDetailOpen, setDeviceDetailOpen] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [fotaOpen, setFotaOpen] = useState<boolean>(false)

  const checkPageMounted = useRef(false)
  const assignPageMounted = useRef(false)
  const assignMounted = useRef(false)
  const tabMounted = useRef(false)

  const [checkRows, setCheckRows] = useState<any[]>([])
  const [allocationRows, setAllocationRows] = useState<any[]>([])

  const loadImageSizeToRows = (
    rows: any[],
    setRows: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
    rows.forEach((row) => {
      if (!row?.filePath || row.imageWidth) return

      const img = new Image()
      img.src = envImagePath + row.filePath

      img.onload = () => {
        setRows((prev) =>
          prev.map((r) =>
            r.id === row.id ? {...r, imageWidth: img.width, imageHeight: img.height} : r
          )
        )
      }

      img.onerror = () => {
        setRows((prev) =>
          prev.map((r) => (r.id === row.id ? {...r, imageWidth: null, imageHeight: null} : r))
        )
      }
    })
  }

  const imageDetailModalOpen = () => {
    setImageDetailOpen(true)
  }
  const imageDetailModalClose = () => {
    setImageDetailOpen(false)
  }
  const deviceDetailModalOpen = () => {
    setDeviceDetailOpen(true)
  }
  const deviceDetailModalClose = () => {
    setDeviceDetailOpen(false)
  }

  const onAllocationsSelectionHandler = (ids: any) => {
    const selectedRowsData = ids.map((id: any) =>
      allocationRows.find((row) => String(row.id) === String(id))
    )
    setAllocationSelectCheckbox(selectedRowsData.filter(Boolean))
  }
  const onRowsSelectionHandler = (ids: any) => {
    const selectedRowsData = ids.map((id: any) =>
      checkRows.find((row) => String(row.id) === String(id))
    )
    setCheckSelectCheckbox(selectedRowsData.filter(Boolean))
  }
  const checkColumns: any = deviceCheckColumns(
    setDeviceDetailData,
    imageDetailModalOpen,
    deviceDetailModalOpen
  )
  const allocationColumns: any = deviceAssignColumns(
    setDeviceDetailData,
    imageDetailModalOpen,
    deviceDetailModalOpen
  )

  useEffect(() => {
    if (!totalData) return

    const rows = deviceCheckRows(totalData).map((row: any) => ({
      ...row,
      imageWidth: null,
      imageHeight: null,
    }))

    setCheckRows(rows)
    loadImageSizeToRows(rows, setCheckRows)
  }, [totalData])

  // ✅ [추가]
  useEffect(() => {
    if (!assignedData) return

    const rows = deviceAllocationRows(assignedData).map((row: any) => ({
      ...row,
      imageWidth: null,
      imageHeight: null,
    }))

    setAllocationRows(rows)
    loadImageSizeToRows(rows, setAllocationRows)
  }, [assignedData])

  const getDeviceCheckListCall = () => {
    getDeviceCheckList(cooperInfo, checkFilter, {
      success: (res: any) => {
        setTotalData(res)
      },
      count: (count: any) => {
        setCheckTotalCount(count ?? 0)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const getDeviceAssignedListCall = () => {
    getDeviceAssignList(cooperInfo, assignFilter, {
      success: (res: any) => {
        setAssignedData(res)
      },
      count: (count: any) => {
        setAssignTotalCount(count ?? 0)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const checkButtonHandlerCall = async (type: string) => {
    checkButtonHandler(type, checkSelectCheckbox, userInfo, {
      success: (res: any) => {
        if (res.resultCode === 0) {
          resetHandler()
        }
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const allocationHandlerCall = async () => {
    allocationCancelHandler(allocationSelectCheckbox, {
      success: (res: any) => {
        if (res.resultCode === 0) {
          resetHandler()
        }
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }

  /**
   * 검색 버튼은 항상 1페이지부터 다시 본다.
   * 이미 1페이지면 이펙트가 안 도니 직접 호출한다.
   */
  const checkSearchHandler = () => {
    if (checkFilter.page !== 1) {
      setCheckFilter((prev: any) => ({...prev, page: 1}))
      return
    }
    getDeviceCheckListCall()
  }

  const assignSearchHandler = () => {
    if (assignFilter.page !== 1) {
      setAssignFilter((prev: any) => ({...prev, page: 1}))
      return
    }
    getDeviceAssignedListCall()
  }

  const resetHandler = () => {
    setCheckSelectCheckbox([])
    setAllocationSelectCheckbox([])
    setCheckSelectionModel([])
    setAssignSelectionModel([])
    if (value === 0) {
      getDeviceCheckListCall()
    } else {
      getDeviceAssignedListCall()
    }
  }

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 280,
      240: 260,
      144: 180,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    // 기본값
    return 180
  }

  /**
   * 검수 탭은 서버 페이징이라 조회 조건과 페이지 이동을 나눠서 처리한다.
   * 조건이 바뀌면 먼저 1페이지로 되돌리고, 실제 호출은 페이지 이펙트가 한 번만 맡는다.
   * (한 이펙트에 다 몰면 조건 변경 때 이전 페이지로 한 번, 1페이지로 또 한 번 호출된다.)
   */
  useEffect(() => {
    if (checkFilter.page !== 1) {
      setCheckFilter((prev: any) => ({...prev, page: 1}))
      return
    }
    scrollTop()
    getDeviceCheckListCall()
  }, [checkFilter.checkStatus, checkFilter.startDate, checkFilter.endDate, cooperInfo])

  useEffect(() => {
    if (!checkPageMounted.current) {
      checkPageMounted.current = true
      return
    }
    scrollTop()
    setCheckSelectionModel([])
    setCheckSelectCheckbox([])
    getDeviceCheckListCall()
  }, [checkFilter.page, checkFilter.rowPerPage])

  useEffect(() => {
    if (!assignMounted.current) {
      // 첫 진입에는 검수 탭만 조회한다. 할당 목록은 탭을 옮길 때 아래 이펙트가 부른다.
      assignMounted.current = true
      return
    }
    if (assignFilter.page !== 1) {
      setAssignFilter((prev: any) => ({...prev, page: 1}))
      return
    }
    scrollTop()
    getDeviceAssignedListCall()
  }, [assignFilter.assignStatus, cooperInfo])

  useEffect(() => {
    if (!assignPageMounted.current) {
      assignPageMounted.current = true
      return
    }
    scrollTop()
    setAssignSelectionModel([])
    setAllocationSelectCheckbox([])
    getDeviceAssignedListCall()
  }, [assignFilter.page, assignFilter.rowPerPage])

  useEffect(() => {
    if (!tabMounted.current) {
      tabMounted.current = true
      return
    }
    resetHandler()
  }, [value])
  return (
    <>
      <MeterariumTabPanel id={'device-allocation-check'} value={value} index={0}>
        <MeterariumPageLayout
          headerDescription={toolTipText.deviceAllocation.description}
          tooltipText={toolTipText.deviceAllocation.text}
          hideSearchOptions={accordionOpen}
          setHideSearchOptions={setAccordionOpen}
          filter={checkFilter}
          id={'device-allocation-check'}
          setFilter={setCheckFilter}
          searchCallback={checkSearchHandler}
          total={checkTotalCount}
          selectedCount={checkSelectCheckbox?.length}
          control={['checkStatus', 'betweenRange']}
          actions={['deviceCheck', 'deviceDelete']}
          searchOptions={['serialNumber', 'imei']}
          date={date}
          setDate={setDate}
          buttonHandler={checkButtonHandlerCall}
          checkData={checkSelectCheckbox}
          onDelete={null}
          onCancel={null}
          setTypeName={null}
          onFotaOpen={() => setFotaOpen(true)}
          pannel={
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                backgroundColor: '#fff',
                paddingLeft: 3,
              }}
            >
              <Tabs
                value={value}
                onChange={(e, newValue) => tapHandleChange(newValue, setValue)}
                aria-label='check-list-tab'
              >
                <Tab label='검수 조회' {...a11yProps(0)} className={'font-extrabold'} />
                <Tab label='할당 조회' className={'font-extrabold'} {...a11yProps(1)} />
              </Tabs>
            </Box>
          }
        >
          {isMobile ? (
            <>
              <DeviceAllocationMobileCard
                rows={checkRows}
                loading={loading}
                selectionModel={checkSelectionModel}
                onSelectionChange={(ids) => {
                  onRowsSelectionHandler(ids)
                  setCheckSelectionModel(ids)
                }}
                mode='check'
                onImageDetailOpen={imageDetailModalOpen}
                onDeviceDetailOpen={deviceDetailModalOpen}
                setDeviceDetailData={setDeviceDetailData}
              />
              <CustomPagination
                filter={checkFilter}
                setFilter={setCheckFilter}
                totalCount={checkTotalCount}
              />
            </>
          ) : (
            <>
              <DataGridPro
                rowHeight={160}
                getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
                autoHeight={true}
                scrollbarSize={60}
                rows={checkRows}
                columns={checkColumns}
                columnGroupingModel={deviceCheckGroup}
                experimentalFeatures={{columnGrouping: true}}
                disableColumnMenu
                selectionModel={checkSelectionModel}
                onSelectionModelChange={(ids) => {
                  onRowsSelectionHandler(ids)
                  setCheckSelectionModel(ids)
                }}
                paginationMode={'server'}
                pagination={true}
                hideFooterPagination={true}
                hideFooter={true}
                checkboxSelection
                loading={loading}
              />
              <CustomPagination
                filter={checkFilter}
                setFilter={setCheckFilter}
                totalCount={checkTotalCount}
              />
            </>
          )}
        </MeterariumPageLayout>
      </MeterariumTabPanel>
      <MeterariumTabPanel id={'device-allocation-assign'} value={value} index={1}>
        <MeterariumPageLayout
          headerDescription={toolTipText.deviceAllocation.description}
          tooltipText={toolTipText.deviceAllocation.text}
          hideSearchOptions={accordionOpen}
          setHideSearchOptions={setAccordionOpen}
          filter={assignFilter}
          id={'device-allocation-assign'}
          setFilter={setAssignFilter}
          searchCallback={assignSearchHandler}
          total={assignTotalCount}
          selectedCount={allocationSelectCheckbox?.length}
          control={['assign']}
          actions={['deviceAssign']}
          searchOptions={['serialNumber', 'imei', 'installerId', 'installerName']}
          date={date}
          checkData={allocationSelectCheckbox}
          setDate={setDate}
          onDelete={null}
          onCancel={allocationHandlerCall}
          setTypeName={setTypeName}
          pannel={
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                backgroundColor: '#fff',
                paddingLeft: 3,
              }}
            >
              <Tabs
                value={value}
                onChange={(e, newValue) => tapHandleChange(newValue, setValue)}
                aria-label='check-list-tab'
              >
                <Tab label='검수 조회' {...a11yProps(0)} className={'font-extrabold'} />
                <Tab label='할당 조회' className={'font-extrabold'} {...a11yProps(1)} />
              </Tabs>
            </Box>
          }
        >
          {isMobile ? (
            <>
              <DeviceAllocationMobileCard
                rows={allocationRows}
                loading={loading}
                selectionModel={assignSelectionModel}
                onSelectionChange={(ids) => {
                  onAllocationsSelectionHandler(ids)
                  setAssignSelectionModel(ids)
                }}
                mode='assign'
                onImageDetailOpen={imageDetailModalOpen}
                onDeviceDetailOpen={deviceDetailModalOpen}
                setDeviceDetailData={setDeviceDetailData}
              />
              <CustomPagination
                filter={assignFilter}
                setFilter={setAssignFilter}
                totalCount={assignTotalCount}
              />
            </>
          ) : (
            <>
              <DataGridPro
                scrollbarSize={60}
                getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
                rows={allocationRows}
                rowHeight={160}
                autoHeight={true}
                columns={allocationColumns}
                columnGroupingModel={deviceAssignGroup}
                experimentalFeatures={{columnGrouping: true}}
                disableColumnMenu
                selectionModel={assignSelectionModel}
                paginationMode={'server'}
                pagination={true}
                hideFooterPagination={true}
                hideFooter={true}
                loading={loading}
                checkboxSelection
                onSelectionModelChange={(ids) => {
                  onAllocationsSelectionHandler(ids)
                  setAssignSelectionModel(ids)
                }}
              />
              <CustomPagination
                filter={assignFilter}
                setFilter={setAssignFilter}
                totalCount={assignTotalCount}
              />
            </>
          )}
        </MeterariumPageLayout>
      </MeterariumTabPanel>
      <DeviceTargetImageListModal
        data={deviceDetailData}
        open={imageDetailOpen}
        onClose={imageDetailModalClose}
      />
      <DeviceAssignModal
        toast={toast}
        data={allocationSelectCheckbox}
        typeName={typeName}
        resetHandler={resetHandler}
      />
      <DeviceDetailInfoModal
        data={deviceDetailData}
        open={deviceDetailOpen}
        onClose={deviceDetailModalClose}
        getList={value === 0 ? getDeviceCheckListCall : getDeviceAssignedListCall}
      />
      <ToastContainer />
      <DeviceAllocationBatchRegisterOffcanvas toast={toast} />
      <DeviceFotaBatchOffcanvas toast={toast} open={fotaOpen} onClose={() => setFotaOpen(false)} />
    </>
  )
}

export default DeviceAllocation
